var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValidTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.15846 0 0 5.15846 0 11.5C0 17.8415 5.15846 23 11.5 23C17.8415 23 23 17.8415 23 11.5C23 5.15846 17.8415 0 11.5 0ZM17.3848 7.1891C17.7243 7.4903 17.7551 8.00973 17.4538 8.34905L10.8823 15.7419C10.5578 16.1072 9.98815 16.1102 9.65982 15.7485L5.55268 11.2306C5.24802 10.8948 5.27315 10.3755 5.60887 10.0707C5.94473 9.76601 6.46394 9.79115 6.76881 10.1268L10.2615 13.9676L16.2249 7.25824C16.5528 6.90107 17.0595 6.89877 17.3848 7.18925L17.3848 7.1891Z",
    fill: "#F22B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidTick);
export default __webpack_public_path__ + "static/media/validTick.88ea044ffc2b32ac4db8dac7e9f06a94.svg";
export { ForwardRef as ReactComponent };